import { render, staticRenderFns } from "./LandmarkList.vue?vue&type=template&id=3bb4322e&"
import script from "./LandmarkList.vue?vue&type=script&lang=js&"
export * from "./LandmarkList.vue?vue&type=script&lang=js&"
import style0 from "./LandmarkList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports